import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import { getMyOrder } from "../../api/orders";
import type { Order } from "../../api/orders";

export function myOrderQueryKey(orderId: string) {
  return ["my-orders", "detail", orderId] as const;
}

/** useMyOrder загружает карточку заказа покупателя по id. */
export function useMyOrder(orderId: string): UseQueryResult<Order, Error> {
  return useQuery({
    queryKey: myOrderQueryKey(orderId),
    queryFn: ({ signal }) => getMyOrder(orderId, signal),
  });
}
